var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tips-box"},[_c('div',{staticClass:"tips-item",on:{"click":_vm.scrollToTop}},[_c('el-image',{staticStyle:{"width":"32px","height":"25px"},attrs:{"src":require('@/assets/common/top.gif'),"fit":"contain"}}),_c('span',[_vm._v("回到顶部")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }